// extracted by mini-css-extract-plugin
export default {"left":"DZBm0d","center":"DCTXbr","right":"hQAwYk","onImage":"Gangn7","offImage":"njGJnp"};